import { apiSecond } from '@/boot/axios'

// Сколько страниц ленты просматриваем в поисках обновления, пока у бэка нет
// эндпоинта одного обновления (по 50 записей — это 500 последних обновлений)
const SCAN_PER_PAGE = 50
const SCAN_MAX_PAGES = 10

function isNotFound(error) {
	const status = error && error.response && error.response.status
	return status === 404 || status === 405
}

async function findInList(id) {
	for (let page = 1; page <= SCAN_MAX_PAGES; page++) {
		const { data } = await apiSecond.get('v1/public/system-updates', {
			params: { page, per_page: SCAN_PER_PAGE },
		})
		const list = Array.isArray(data && data.data) ? data.data : []
		const found = list.find((item) => item && item.id === id)
		if (found) return found
		if (!list.length || page >= (Number(data.last_page) || 1)) return null
	}
	return null
}

// Одно опубликованное обновление для страницы /updates/:id.
// Сначала GET public/system-updates/{id}; если бэк такого роута ещё не знает (404),
// ищем запись в ленте — так страница работает и до, и после доработки бэка.
// Возвращает объект обновления или null, если оно не найдено/не опубликовано.
export async function fetchPublicUpdate(id) {
	try {
		const { data } = await apiSecond.get('v1/public/system-updates/' + id)
		const item = data && (data.data || data)
		if (item && item.id === id) return item
	} catch (error) {
		if (!isNotFound(error)) throw error
	}
	return findInList(id)
}
